import React, {FunctionComponent} from 'react';
import IconEmptyCalendar from '../icon/IconEmptyCalendar';
import IconStudent from '../icon/IconStudent';
import IconFeedback from '../icon/IconFeedback';
import IconCertificate from '../icon/IconCertificate';
import LastEventsRow from './LastEventsRow';
import {PastEvent} from './PastEvents';
import ScheduleFormatter from '../../models/formatter/ScheduleFormatter';
import Schedule from '../../models/event/Schedule';
import Tooltip from '../../ui/Tooltip';

type LastEventsTableProps = {
  events: PastEvent[]
}

const LastEventsTable: FunctionComponent<LastEventsTableProps> = ({events}) =>
  (
    <div className="grid grid-cols-12 gap-x-1 gap-y-4 text-base pt-3">
      <div className="col-span-6 text-gray-dark">Title</div>
      <div className="col-span-6">
        <div className="grid grid-cols-7">
          <div className="col-span-4"><IconEmptyCalendar className="text-gray-dark"/></div>
          <div className="text-right">
            <Tooltip content="Number of students" label="students"><IconStudent className="text-green"/></Tooltip>
          </div>
          <div className="text-right">
            <Tooltip content="Number of evaluations" label="evaluations"><IconFeedback className="text-gray-dark"/></Tooltip>
          </div>
          <div className="text-right">
            <Tooltip content="Number of certificates" label="certificates">
              <IconCertificate className="text-blue"/>
            </Tooltip>
          </div>
        </div>
      </div>
      {events.map((event) => <LastEventsRow key={event.id} title={event.title} id={event.id}
        date={ScheduleFormatter.format('en-GB', new Schedule(event.schedule), 'interval')}
        students={event.statistics.students} evaluations={event.statistics.evaluations}
        certificates={event.statistics.certificates}/>)}

    </div>
  );

export default LastEventsTable;
